module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "captcha"
  }, [(!_vm.isReady) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _c('div', {
    staticClass: "bounce2"
  }), _c('div', {
    staticClass: "bounce3"
  })]) : _vm._e(), _c('div', {
    attrs: {
      "id": _vm.ActiveCaptcha
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd74e96","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/captcha.vue
// module id = 511
// module chunks = 0 4 5 9